// User-facing removal reasons (shown in dropdowns for regular users)
export const USER_REMOVAL_REASONS = {
  ADOPTED_HERE: 'Adopted on Home To Home',
  ADOPTED_ELSEWHERE: 'Pet was rehomed through another site',
  FOSTERED_HERE: 'Fostered through this site',
  FOSTERED_ELSEWHERE: 'Fostered through another site',
  ADOPTED_BY_FAMILY_FRIEND: 'Family or friend adopted my pet',
  FOSTERED_BY_FAMILY_FRIEND: 'Family or friend fostered my pet',
  KEPT_PET: 'I kept my pet',
  GAVE_TO_SHELTER: 'Took my pet to a shelter',
  GAVE_TO_RESCUE: 'Gave my pet to a rescue',
  PASSED_AWAY: 'Passed Away/Euthanized',
} as const

// All removal reasons including admin-only ones (for display purposes)
export const REMOVAL_REASONS = {
  ...USER_REMOVAL_REASONS,
  ADMIN_REMOVAL: 'Admin Removal',
} as const

export const REJECTION_REASONS = {
  OUT_OF_JURISDICTION: 'Out of Jurisdiction',
  ILLEGAL_ANIMAL: 'Illegal Animal Posted',
  INAPPROPRIATE_CONTENT: 'Inappropriate Content',
  ANIMAL_AGGRESSION: 'Cannot post - Animal Aggression',
  SUSPICIOUS_POST: 'Suspicious Post',
  DUPLICATED_POST: 'Duplicated Post',
  NO_RESPONSE: 'No Response',
} as const
